import './PetListDetails.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '@/routes';
import { ReactComponent as DeleteIcon } from '@/assets/img/delete-icon-v2.svg';
import { ReactComponent as SelectedIcon } from '@/assets/img/selected-tick.svg';
import { ReactComponent as DeSelectedIcon } from '@/assets/img/deselected-tick.svg';

import { Pets } from '@/features/customers';
import { ReactComponent as PetCat } from '@/assets/img/pet-type-cat.svg';
import { ReactComponent as PetDog } from '@/assets/img/pet-type-dog.svg';
import { useTranslation } from 'react-i18next';
type PetTypeProps = {
  onChange: (type: Pets) => void;
  data?: any;
  isSelected?: boolean;
  showDeleteOption?: boolean;
  onDelete?: (pet: Pets) => void;
};
export const PetListDetails = ({
  onChange,
  data,
  isSelected,
  showDeleteOption,
  onDelete,
}: PetTypeProps) => {
  const userContext = useContext(UserContext);
  const { t, i18n } = useTranslation();
  useEffect(() => {}, [isSelected]);
  const onDeleteClick = (e: any) => {
    e?.stopPropagation();
    onDelete && onDelete(data);
  };
  return (
    <div
      className={`pet-list-details ${data.id ? '' : 'new-pet'} ${isSelected ? 'selected-pet' : ''}`}
      onClick={() => {
        onChange(data);
      }}
    >
      <div className="left-section">
        <div className="pets-image">
          {data?.petsImageUrl ? (
            <img src={data.petsImageUrl} />
          ) : data?.petType?.toLowerCase() === 'cat' ? (
            <PetCat />
          ) : (
            <PetDog />
          )}
        </div>
        <div className="details">
          <div className="name" title={data.name}>
            {data.name}
          </div>
          <div className="breed" title={data.breed}>
            {data.breed}
          </div>
        </div>
      </div>
      <div className="right-section">
        {showDeleteOption ? (
          <DeleteIcon className="delete-icon" onClick={onDeleteClick} />
        ) : isSelected ? (
          <SelectedIcon className="delete-icon" />
        ) : (
          <DeSelectedIcon className="delete-icon" />
        )}
      </div>
      {/* {showDeleteOption ? (
        <DeleteIcon className="delete-icon" onClick={onDeleteClick} />
      ) : isSelected ? (
        <SelectedIcon className="delete-icon" />
      ) : (
        <DeSelectedIcon className="delete-icon" />
      )} */}
    </div>
  );
};
